import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from './endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

// Define a service using a base URL and expected endpoints
export const excelRevenueApi: any = createApi({
  reducerPath: 'excelRevenueApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['excelRevenue'],
  endpoints: (builder) => ({
    exportToExcel: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.RevenueExcelExportReportController.exportToExcel}${body.fileName}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
          responseType: 'blob',
        };
      },
    }),
  }),
});



export const { useExportToExcelMutation } = excelRevenueApi;
